import type { QueryClient } from "@tanstack/react-query";
import { createRouter, type RouterHistory } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

export const createProcurementRouter = ({
  history,
  queryClient,
}: {
  history?: RouterHistory;
  queryClient: QueryClient;
}) =>
  createRouter({
    routeTree,
    context: { queryClient },
    ...(history ? { history } : {}),
  });

export type ProcurementRouter = ReturnType<typeof createProcurementRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: ProcurementRouter;
  }
}
